<ng-container *ngComponentOutlet="startupService.contentContainer()" />
